import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  private captchaToken = new BehaviorSubject<string | null>(null);
  private captchaRequired = new BehaviorSubject<boolean>(false);
  private tokenTimestamp: number | null = null;
  private readonly TOKEN_VALIDITY_DURATION = 120000; // 2 minutes in milliseconds

  setCaptchaToken(token: string | null): void {
    this.captchaToken.next(token);
    this.tokenTimestamp = token ? Date.now() : null;
  }

  getCaptchaToken(): Observable<string | null> {
    return this.captchaToken.asObservable();
  }

  getCaptchaTokenValue(): string | null {
    return this.captchaToken.value;
  }

  isTokenValid(): boolean {
    const token = this.captchaToken.value;
    if (!token || !this.tokenTimestamp) {
      return false;
    }

    const now = Date.now();
    const elapsed = now - this.tokenTimestamp;
    return elapsed < this.TOKEN_VALIDITY_DURATION;
  }

  setCaptchaRequired(required: boolean): void {
    this.captchaRequired.next(required);
  }

  isCaptchaRequired(): Observable<boolean> {
    return this.captchaRequired.asObservable();
  }

  resetCaptcha(): void {
    this.captchaToken.next(null);
    this.tokenTimestamp = null;
    this.captchaRequired.next(false);
  }
}
